import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedThanks = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 49,
	viewBox: "0 0 48 49",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M21.2298 33.6041L35.1829 19.651L32.4121 16.8802L21.2298 28.0625L15.5892 22.4219L12.8184 25.1927L21.2298 33.6041ZM24.0007 44.2916C21.2628 44.2916 18.6899 43.7721 16.2819 42.7331C13.8739 41.694 11.7793 40.2838 9.99805 38.5026C8.2168 36.7213 6.80664 34.6267 5.76758 32.2187C4.72852 29.8107 4.20898 27.2378 4.20898 24.5C4.20898 21.7621 4.72852 19.1892 5.76758 16.7812C6.80664 14.3732 8.2168 12.2786 9.99805 10.4974C11.7793 8.71613 13.8739 7.30597 16.2819 6.26691C18.6899 5.22784 21.2628 4.70831 24.0007 4.70831C26.7385 4.70831 29.3114 5.22784 31.7194 6.26691C34.1274 7.30597 36.222 8.71613 38.0033 10.4974C39.7845 12.2786 41.1947 14.3732 42.2337 16.7812C43.2728 19.1892 43.7923 21.7621 43.7923 24.5C43.7923 27.2378 43.2728 29.8107 42.2337 32.2187C41.1947 34.6267 39.7845 36.7213 38.0033 38.5026C36.222 40.2838 34.1274 41.694 31.7194 42.7331C29.3114 43.7721 26.7385 44.2916 24.0007 44.2916Z",
		fill: "url(#paint0_linear_2172_12332)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_2172_12332",
		x1: 4.0007,
		y1: 44.8125,
		x2: 50.6835,
		y2: 14.4687,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#2563EB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CACBFF"
			})
		]
	}) })]
});
export default SvgExtendedThanks;
